const locale = require('./chatMembersDropdown.i18n.json');

/*@ngInject*/
const ChatMembersDropdownController = function ($element, $uibModal, currentUserModel, formatUtil) {
    this.$onInit = function () {
        $element.addClass('chatMembersDropdown');

        this.i18n = locale;
        this.currentUserId = currentUserModel.getCurrentUser().userId;
    };

    this.getChatMemberNameSelector = function (chatMember) {
        let chatMemberName = chatMember.firstName + chatMember.lastName;
        return formatUtil.formatAsSelector(chatMemberName);
    };

    this.inviteChatUser = function () {
        $uibModal.open({
            templateUrl: '/collaboration/chat/inviteChat/inviteChatModal.tpl.html',
            controller: 'inviteChatModalController',
            windowClass: 'inviteChatModal',
            keyboard: false,
            backdrop: 'static'
        });
    };

};

angular.module('gw-um-submission')
    .controller('chatMembersDropdownController', ChatMembersDropdownController);

